import { Lock } from "lucide-react";
import type { Role } from "@/api/types";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ROLE_META } from "@/lib/status";
import { StatusBadge } from "./StatusBadge";

export function RoleBadge({ role, fixedAdmin }: { role: Role; fixedAdmin?: boolean }) {
  const m = ROLE_META[role];
  return (
    <span className="inline-flex items-center gap-1">
      <StatusBadge tone={m.tone} label={m.label} icon={m.icon} />
      {fixedAdmin && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={0} role="img" aria-label="Fixed admin" className="inline-flex text-muted-foreground">
              <Lock aria-hidden className="size-3.5" />
            </span>
          </TooltipTrigger>
          <TooltipContent>Fixed admin</TooltipContent>
        </Tooltip>
      )}
    </span>
  );
}
